import { Breadcrumb, Button, Copy, Drawer, Flex, Image, LegacyCard, Page, Typography } from "@payping/web-components";
import { SubLayout } from "@/components/SubLayout";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { Close, CuToman } from "@payping/icons";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import React from "react";
import { TransferMethodEnum } from "@payping/api";
import { URLS } from "@payping/utilities-shared/consts";

interface Props {
  openDrawer: boolean;
  transferType?: TransferMethodEnum;
}

const FinalStatus: React.FC<Props> = ({ openDrawer }) => {
  const { t } = useAppTranslation();
  const { overviewDetail } = useAppSelector((state) => state.digitalAccount.saman);
  const paymentDetailsModels = useAppSelector((state) => state.digitalAccount.saman.requestList?.paymentDetailsModels);

  return (
    <Drawer
      title={
        <Breadcrumb
          items={[
            { title: t("digitalAccount.samanCreate.samanOperation") },
            { title: t("digitalAccount.samanCreate.finalStatus") },
          ]}
        />
      }
      open={openDrawer}
      closeIcon={false}
      placement={"bottom"}
      size={"100%"}
      extra={
        <Link to={DashboardRoutes.digitalAccount.yourAccount.url}>
          <Button type={"text"} icon={<Close width={14} height={14} />}></Button>
        </Link>
      }
    >
      <Page>
        <SubLayout>
          <Flex vertical gap={"large"}>
            <div className="tw:flex! tw:justify-center!">
              <Image src={`${URLS.STORAGE_URL}/img/Succesful.png`} preview={false} height={128} width={128} />
            </div>
            <Typography.Title level={4} className="tw:flex! tw:justify-center!">
              {t("digitalAccount.samanCreate.final.sentRequestTransfer")}
            </Typography.Title>
            <div className="tw:flex! tw:justify-center!">
              <Link to={DashboardRoutes.digitalAccount.yourAccount.url}>
                <Button type={"primary"}>{t("digitalAccount.samanCreate.final.iRealized")}</Button>
              </Link>
            </div>
            <div className="tw:flex! tw:justify-center!">
              <LegacyCard.Ant className={"tw:w-[600px]"}>
                <Flex vertical gap={"small"}>
                  <div className="tw:flex tw:justify-between">
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanCreate.final.listTransferName")}
                    </Typography.Text>
                    <Typography.Text>{overviewDetail.name}</Typography.Text>
                  </div>
                  <div className="tw:flex tw:justify-between">
                    <Typography.Text type={"secondary"} ellipsis>
                      {t("digitalAccount.samanCreate.final.desc")}
                    </Typography.Text>
                    <Typography.Text>{overviewDetail.description}</Typography.Text>
                  </div>
                  <div className="tw:flex tw:justify-between">
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanCreate.final.numberOfRequest")}
                    </Typography.Text>
                    <Typography.Text>{paymentDetailsModels?.length}</Typography.Text>
                  </div>
                  <div className="tw:flex tw:justify-between">
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanCreate.final.totalAmount")}
                    </Typography.Text>
                    <Flex align="center">
                      <Typography.Text>
                        {overviewDetail.amount
                          ? `${formatLocalizedNumber({ value: overviewDetail.amount / 10 })}`
                          : "-"}
                      </Typography.Text>
                      <CuToman width={24} height={24} />
                    </Flex>
                  </div>
                  <div className="tw:flex tw:justify-between">
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanCreate.final.trackingCode")}
                    </Typography.Text>
                    <Copy showIcon text={overviewDetail.trackingId || ""}>
                      <Typography.Text>{overviewDetail.trackingId}</Typography.Text>
                    </Copy>
                  </div>
                  <div className="tw:flex tw:justify-between">
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanCreate.final.bankTrackingCode")}
                    </Typography.Text>
                    <Copy showIcon text={overviewDetail.id || ""}>
                      <Typography.Text>{overviewDetail.id}</Typography.Text>
                    </Copy>
                  </div>
                </Flex>
              </LegacyCard.Ant>
            </div>
          </Flex>
        </SubLayout>
      </Page>
    </Drawer>
  );
};

export default FinalStatus;
